import Vue from "vue";
import Vuex from "vuex";
import gen from "random-seed";

const random = gen.create();
const MAX_BOMB_THRESHOLD = 75;

Vue.use(Vuex);

const state = {
  bin: [],
  binSize: 5,
  board: [],
  boardSize: [5, 5],
  bonusTiles: [],
  bombs: 0,
  bombThreshold: 40,
  holdTile: {},
  isGameOver: false,
  isNextTileReady: true,
  roundIndex: 0,
  score: 0,
  scoreTargets: [],
  tiles: [],
};

const getters = {
  getBin(state) {
    return state.bin;
  },

  getBinSize(state) {
    return state.binSize;
  },

  getBoard(state) {
    return state.board;
  },

  getBoardSize(state) {
    return state.boardSize;
  },

  getBonusTiles(state) {
    return state.bonusTiles;
  },

  getBombs(state) {
    return state.bombs;
  },

  getBombThreshold(state) {
    return state.bombThreshold;
  },

  getHoldTile(state) {
    return state.isNextTileReady ? state.holdTile : {};
  },

  getIsGameOver(state) {
    return state.isGameOver;
  },

  getRoundIndex(state) {
    return state.roundIndex;
  },

  getNextTile(state) {
    return state.isNextTileReady ? state.tiles[state.roundIndex] : null;
  },

  getPreviewTile(state) {
    return state.roundIndex + 1 < state.tiles.length && state.isNextTileReady
      ? state.tiles[state.roundIndex + 1]
      : null;
  },

  getScore(state) {
    return state.score;
  },

  getScoreTargets(state) {
    return state.scoreTargets;
  },

  getIsNextTileReady(state) {
    return state.isNextTileReady;
  },
};

const mutations = {
  setGameState: (state, payload) => {
    const { tiles, holdTile, board, status, score, bombs, bombThreshold } =
      payload;
    state.tiles = tiles;
    state.board = board;
    state.holdTile = holdTile;
    state.isGameOver = status;
    state.score = score;
    state.bombs = Number.isFinite(Number(bombs)) ? Number(bombs) : 0;
    state.bombThreshold = Number.isFinite(Number(bombThreshold))
      ? Math.min(Number(bombThreshold), MAX_BOMB_THRESHOLD)
      : 40;
  },

  addToTiles: (state, payload) => {
    state.tiles.push(...payload);
  },

  addToBin: (state, payload) => {
    state.bin.push(payload);
  },

  removeFromBoard: (state, payload) => {
    payload.forEach((indices) => {
      state.board[indices[0]][indices[1]] = {};
    });
  },

  setBin: (state, payload) => {
    state.bin = payload;
  },

  setBinSize: (state, payload) => {
    state.binSize = payload;
  },

  setBoard: (state, payload) => {
    state.board = payload;
  },

  setBoardSize: (state, payload) => {
    state.boardSize = payload;
  },

  setBonusTiles: (state, payload) => {
    state.bonusTiles = payload;
  },

  setHoldTile: (state, payload) => {
    state.holdTile = payload;
  },

  setIsGameOver: (state, payload) => {
    state.isGameOver = payload;
  },

  setRoundIndex: (state, payload) => {
    state.roundIndex = payload;
  },

  setScore: (state, payload) => {
    state.score = payload;
  },

  setScoreTargets: (state, payload) => {
    state.scoreTargets = payload;
  },

  setTiles: (state, payload) => {
    state.tiles = payload;
  },

  setIsNextTileReady: (state, payload) => {
    state.isNextTileReady = payload;
  },

  updateBoard: (state, payload) => {
    const col = payload.col;
    const row = payload.row;
    const tile = payload.tile;

    state.board[row][col] = tile;
  },

  updateRound: (state, type) => {
    if (type !== "hold") {
      state.roundIndex++;
    }
  },

  updateScore: (state, wordScore) => {
    state.score += wordScore;
  },
};

const actions = {
  initiateBoard: async ({ commit, dispatch }, payload) => {
    const columns = 5;
    const rows = 5;
    const binSize = 5;

    commit("setBoardSize", [rows, columns]);

    let board = [];
    for (let indexRow = 0; indexRow < rows; indexRow++) {
      board[indexRow] = [];

      for (let indexCol = 0; indexCol < columns; indexCol++) {
        board[indexRow][indexCol] = {};
      }
    }

    commit("setBinSize", binSize);
    commit("setBoard", board);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/endless.module.js